export default function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="border-t px-6 py-5">
      <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide">{title}</h3>
      {children}
    </section>
  )
}
